import {
  animation_default
} from "./chunk-POSTVCTR.mjs";
import {
  custom_default
} from "./chunk-MPVWW3DX.mjs";
import {
  scrollbar_hide_default
} from "./chunk-WH6SPIFG.mjs";
import {
  text_default
} from "./chunk-RUIUXVZ4.mjs";
import {
  transition_default
} from "./chunk-GSRZWDGA.mjs";

// src/utilities/index.ts
var utilities = {
  ...custom_default,
  ...transition_default,
  ...scrollbar_hide_default,
  ...text_default,
  ...animation_default
};

export {
  utilities
};
